// extracted by mini-css-extract-plugin
export default {"p_tye":"_03b97f81c4","slcted":"_3ca5f03695","slc_color":"b1c7ce816a","item_p":"d3deaa7674","r0":"ef42ee0ff7"};